/* import __COLOCATED_TEMPLATE__ from './search-results.hbs'; */
import Component from '@glimmer/component';

const LOADING_CARD_ITERABLE = Array(6);

class SearchResults extends Component {

  get showResults() {
    return Boolean(this.args.myNetworkResultsList?.length);
  }

  get loadingCards() {
    return LOADING_CARD_ITERABLE;
  }
}

export default SearchResults;
